/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "AgreementCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
        ],
        name: "AgreementLiquidated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256",
            },
        ],
        name: "AgreementLiquidatedBy",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes",
            },
        ],
        name: "AgreementLiquidatedV2",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256",
            },
        ],
        name: "AgreementStateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "AgreementTerminated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "AgreementUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256",
            },
        ],
        name: "Bailout",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        name: "CodeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "n",
                type: "string",
            },
            {
                internalType: "string",
                name: "s",
                type: "string",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address",
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool",
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256",
            },
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256",
            },
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]",
            },
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class NoNFTSuperTokenMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
NoNFTSuperTokenMock__factory.bytecode = _bytecode;
NoNFTSuperTokenMock__factory.abi = _abi;
//# sourceMappingURL=NoNFTSuperTokenMock__factory.js.map